import React, { useContext } from 'react';

import { ShowIntercomContext } from 'common/containers/IntercomContainer';
import OpenIDConnectSSOLandingHelmet from 'common/helmets/OpenIDConnectSSOLandingHelmet';
import Button from 'common/inputs/Button';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';

import CannyLogoIcon from 'img/canny-icon.svg';
import OIDCLogo from 'img/open-id-connect-logo.png';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

const OpenIDConnectSSOLanding = () => {
  const showIntercom = useContext(ShowIntercomContext);

  return (
    <div className="integrationsLanding withoutImage">
      <OpenIDConnectSSOLandingHelmet />
      <div className="integrationsLandingContainer">
        <div className="header">
          <div className="left">
            <div className="logosCombined">
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={CannyLogoIcon}
                alt="Canny Logo"
              />
              +
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={OIDCLogo}
                alt="OIDC Logo"
              />
            </div>
            <div className="text">
              <h1 className="title">Canny’s OpenID Connect (OIDC) SSO Integration</h1>
              <p className="subtitle">
                Let your employees log in to your Canny account via any OIDC provider.
              </p>
              <div className="links">
                <Button
                  buttonType="blackButton"
                  value="Contact us for access"
                  onTap={showIntercom}
                />
                <a
                  href="https://help.canny.io/en/articles/8047570-openid-connect-oidc-sso-integration"
                  rel="noopener"
                  target="_blank">
                  See install docs
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="features">
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Automatically assign admin roles</h2>
              <p className="subtitle">Control which role your users will have in Canny.</p>
            </div>
          </div>
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Use only on the boards you want</h2>
              <p className="subtitle">
                Choose which of your Canny boards you want authenticated by OIDC.
              </p>
            </div>
          </div>
        </div>
        <LandingFooterCTA style="solid" />
      </div>
    </div>
  );
};

export default OpenIDConnectSSOLanding;
